// src/components/store/sections/faqs/FaqV39CardgridFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV39CardgridFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={39}
      archKey="card_grid"
      archLabel="Support Help Cards"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
